// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__d_nF6","heading":"styles_heading__mPrBL","subscript":"styles_subscript__47JoN","fadeInOut":"styles_fadeInOut__pXJi4","loader":"styles_loader__fd84g"};